import { getAppEnv } from '../config/env';
import { EnvironmentVariables } from './types';
const env = getAppEnv();
const { CABS_FQDN } = env.raw as EnvironmentVariables;

export const getUserDetails = async (mmtAuth: string) => {
  try {
    const body = {
      mmtAuth,
      type: 'userDetailsRequest'
    };
    const headers = {
      authority: 'cabs.makemytrip.com',
      accept: 'application/json'
    };
    const options = {
      headers,
      body: JSON.stringify(body),
      method: 'POST'
    };
    let res = await fetch(
      `https://cabs.makemytrip.com/getUserDetails`,
      options
    );
    res = await res.json();
    return res;
  } catch (ex) {
    console.error('Error at getUserDetails', ex);
    return null;
  }
};

export const getCabConfiguration = async () => {
  try {
    let res = await fetch(`${CABS_FQDN}/cabConfiguration/`);
    res = await res.json();
    return res;
  } catch (ex) {
    console.error('Error at getCabConfiguration', ex);
    return null;
  }
};

export const getCabLandingPlaceHolder = async () => {
  try {
    let res = await fetch(
      `https://cabs.makemytrip.com/landingPlaceholders/v2?platform=web&userType=PERSONAL`
    );
    res = await res.json();
    return res;
  } catch (ex) {
    console.error('Error at getCabLandingPlaceHolder', ex);
    return null;
  }
};

export const getCabOffers = async () => {
  try {
    let res = await fetch(`https://cabs.makemytrip.com/getOffers`);
    res = await res.json();
    return res;
  } catch (ex) {
    console.error('Error at getCabOffers', ex);
    return null;
  }
};
